module.exports = __webpack_public_path__ + "static/media/77.97ce45de.jpg";